<template>
  <div class="wrapper">
    <div class="animated fadeIn">

      <b-row>
        <b-col sm="12">
          <b-card header-class="redmfu">
            <div slot="header">
              <strong v-if="thai_student==1">ตอนที่ 4 การศึกษาต่อ</strong>
              <strong v-else>Part 4 Further Study</strong>
              <div style="float:right;">
                <b-badge pill variant="warning" class="font-sm text-dark p-2 pr-3 pl-3">Session Timeout :
                  {{ this.$store.state.timeExp }}
                </b-badge>
              </div>
            </div>
            <div v-for="item in items" v-bind:key="item.QUESTION_PK">
              <!--              {{ items2[item.QUESTION_PK - 42].VALUES }}-->
              <!--                            {{ item.NUMBER }})-->
              <!--                            {{ item.QUESTION_NAME }}-->

              <div v-if="item.QUESTION_PK==44">
                <b-row>
                  <b-col sm="3" v-if="error_faculty==2" class="text-danger" >*
                    {{ t1 = item.NUMBER }})  {{lbl_faculty}}</b-col>
                  <b-col sm="3" v-else >
                      {{ t1 = item.NUMBER }})  {{lbl_faculty}}
                  </b-col>

                  <b-col sm="7">
                    <b-form-input
                      id="txt_faculty"
                      type="text"
                      autocomplete="txt_faculty"
                      v-model="txt_faculty"
                      placeholder=""
                    ></b-form-input>
                  </b-col>
                </b-row>
              </div>
              <div v-if="item.QUESTION_PK==45">
                <b-row>
                  <b-col sm="3" v-if="error_university==2" class="text-danger" >*
                    {{ t2 = item.NUMBER + 1 }})  {{lbl_university}}</b-col>
                  <b-col sm="3" v-else >
                    {{ t2 = item.NUMBER + 1}})  {{lbl_university}}
                  </b-col>
                  <b-col sm="7">
                    <b-form-input
                      id="txt_university"
                      type="text"
                      autocomplete="txt_university"
                      v-model="txt_university"
                      placeholder=""
                    ></b-form-input>
                  </b-col>
                </b-row>
                <b-row>
                  <b-col sm="3" v-if="error_address_uni==2" class="text-danger" >*
                    {{ t3 = t2 + 1 }})  {{lbl_address_uni}}</b-col>
                  <b-col sm="3" v-else >
                    {{ t3 = t2 + 1}})  {{lbl_address_uni}}
                  </b-col>
                  <b-col sm="7">
                    <b-form-input
                      id="txt_address_uni"
                      type="text"
                      autocomplete="txt_address_uni"
                      v-model="txt_address_uni"
                      placeholder=""
                    ></b-form-input>
                  </b-col>
                </b-row>

              </div>
              <div v-if="(items2[item.QUESTION_PK-42].VALUES ==2)">
                <b-form-group
                  class="text-danger"
                  v-if="item.QUESTION_PK==42"
                  :label="'*  ' +item.NUMBER  + ') '+item.QUESTION_NAME"
                  label-for="basicInlineRadios"
                  :label-cols="12"
                ></b-form-group>
                <b-form-group
                  class="text-danger"
                  v-if=" item.QUESTION_PK==43"
                  :label="'*  ' +item.NUMBER  + ') '+item.QUESTION_NAME"
                  label-for="basicInlineRadios"
                  :label-cols="12"
                ></b-form-group>
                <b-form-group
                  class="text-danger"
                  v-if=" item.QUESTION_PK==44"
                  :label="'*  ' +(t1+1) + ') '+item.QUESTION_NAME"
                  label-for="basicInlineRadios"
                  :label-cols="12"
                ></b-form-group>
                <b-form-group
                  class="text-danger"
                  v-if=" item.QUESTION_PK==45"
                  :label="'*  ' +(t1+4) + ') '+item.QUESTION_NAME"
                  label-for="basicInlineRadios"
                  :label-cols="12"
                ></b-form-group>
                <b-form-group
                  class="text-danger"
                  v-if=" item.QUESTION_PK==46"
                  :label="'*  ' +(t1+5) + ') '+item.QUESTION_NAME"
                  label-for="basicInlineRadios"
                  :label-cols="12"
                ></b-form-group>


              </div>
              <div v-else>
<!--                {{ items2[item.QUESTION_PK-42].VALUES}} == {{item.QUESTION_PK}}-->
                <b-form-group
                  v-if="(items2[item.QUESTION_PK-42].VALUES ==0 ||items2[item.QUESTION_PK-42].VALUES ==1 ) && item.QUESTION_PK==42"
                  :label="''+item.NUMBER  + ') '+item.QUESTION_NAME"
                  label-for="basicInlineRadios"
                  :label-cols="12"
                ></b-form-group>
                <b-form-group
                  v-if="(items2[item.QUESTION_PK-42].VALUES ==0 ||items2[item.QUESTION_PK-42].VALUES ==1 ) && item.QUESTION_PK==43"
                  :label="''+item.NUMBER  + ') '+item.QUESTION_NAME"
                  label-for="basicInlineRadios"
                  :label-cols="12"
                ></b-form-group>
                <b-form-group
                  v-if="(items2[item.QUESTION_PK-42].VALUES ==0 ||items2[item.QUESTION_PK-42].VALUES ==1 ) && item.QUESTION_PK==44"
                  :label="(t1+1) + ') '+item.QUESTION_NAME"
                  label-for="basicInlineRadios"
                  :label-cols="12"
                ></b-form-group>
                <b-form-group
                  v-if="(items2[item.QUESTION_PK-42].VALUES ==0 ||items2[item.QUESTION_PK-42].VALUES ==1 ) && item.QUESTION_PK==45"
                  :label="(t1+4) + ') '+item.QUESTION_NAME"
                  label-for="basicInlineRadios"
                  :label-cols="12"
                ></b-form-group>
                <b-form-group
                  v-if="(items2[item.QUESTION_PK-42].VALUES ==0 ||items2[item.QUESTION_PK-42].VALUES ==1 ) && item.QUESTION_PK==46"
                  :label="(t1+5) + ') '+item.QUESTION_NAME"
                  label-for="basicInlineRadios"
                  :label-cols="12"
                ></b-form-group>
              </div>
              <!--              <b-form-group-->
              <!--                v-else-->
              <!--                :label="''+item.NUMBER  + ') '+item.QUESTION_NAME"-->
              <!--                label-for="basicInlineRadios"-->
              <!--                :label-cols="12"-->
              <!--              ></b-form-group>-->
              <b-form-group
                label-cols-sm="1"
                label
                label-align-sm="right"
                label-for="nested-street"
              >
                <b-form-radio-group
                  v-if="item.QUESTION_PK==42"
                  v-model="selected_level_edu"
                  value-field="BYTECODE"
                  text-field="BYTEDES"
                  :options="items[0].ANS"
                  stacked
                  name="selected_level_edu"
                >
                  <!-- select:{{ selected_level_edu }} -->
                </b-form-radio-group>
                <b-form-radio-group
                  v-if="item.QUESTION_PK==43"
                  v-model="selected_program_edu"
                  value-field="BYTECODE"
                  text-field="BYTEDES"
                  :options="items[1].ANS"
                  stacked
                  name="selected_program_edu"
                >

                  <v-select v-if="selected_program_edu==2"
                            label="PROGRAM_NAME"
                            :options="programItems"
                            v-model="selected_program_id1"
                            @input="selectProgramOnchange"
                  ></v-select>


                </b-form-radio-group>

                <b-form-radio-group
                  v-if="item.QUESTION_PK==44"
                  v-model="selected_type_univ"
                  value-field="BYTECODE"
                  text-field="BYTEDES"
                  :options="items[2].ANS"
                  stacked
                  name="selected_type_univ"
                >
                  <!-- select:{{ selected_type_univ }} -->
                </b-form-radio-group>
                <b-form-radio-group
                  v-if="item.QUESTION_PK==45"
                  v-model="selected_cause_edu"
                  value-field="BYTECODE"
                  text-field="BYTEDES"
                  :options="items[3].ANS"
                  stacked
                  name="selected_cause_edu"
                >
                  <!-- select:{{ selected_cause_edu }} -->
                  <b-form-input
                    v-if="selected_cause_edu=='0'"
                    id="qn_cause_edu_txt"
                    type="text"
                    autocomplete="qn_cause_edu_txt"
                    v-model="qn_cause_edu_txt"
                    placeholder="Other..."
                  ></b-form-input>
                </b-form-radio-group>
                <b-form-radio-group
                  v-if="item.QUESTION_PK==46 && thai_student==0 "
                  v-model="selected_prob_edu_20"
                  value-field="BYTECODE"
                  text-field="BYTEDES"
                  :options="items_prob_eng"

                ></b-form-radio-group>
<!--                select:{{error_prob_edu }}-->
                <b-form-radio-group
                  v-if="item.QUESTION_PK==46 && thai_student==1 "
                  v-model="selected_prob_edu_20"
                  value-field="BYTECODE"
                  text-field="BYTEDES"
                  :options="items_prob_thai"

                ></b-form-radio-group>
                <strong v-if="item.QUESTION_PK==46  && selected_prob_edu_20==2 && thai_student==1 ">(หากตอบมีปัญหา
                  โปรดระบุปัญหา โดยสามารถเลือกตอบได้หลายข้อ)</strong>
                <strong v-if="item.QUESTION_PK==46  && selected_prob_edu_20==2 && thai_student==0 "> (If yes, please
                  choose the reasons. You can choose more than one answer.)</strong>
                <b-form-checkbox-group
                  v-if="item.QUESTION_PK==46 && selected_prob_edu_20==2 "
                  v-model="selected_prob_edu"
                  value-field="BYTECODE"
                  text-field="BYTEDES"
                  :options="items[4].ANS"
                  stacked
                  name="selected_prob_edu"
                >
<!--                                    select:{{selected_prob_edu }}-->
                  <b-form-input

                    id="qn_prob_edu_txt"
                    type="text"
                    autocomplete="qn_prob_edu_txt"
                    v-model="qn_prob_edu_txt"
                    placeholder="Other..."
                  ></b-form-input>
                </b-form-checkbox-group>
              </b-form-group>
            </div>
            <div slot="footer" class="text-center">
              <b-button type="submit" size="md" class="mr-2" variant="success" @click="onBack">
                <i class="fa fa-arrow-circle-o-left"></i> Back
              </b-button>
              <b-button type="submit" size="md" class="mr-2" variant="primary" @click="onSubmit">
                <i class="fa fa-dot-circle-o"></i> Submit
              </b-button>

              <b-button type="reset" size="md" class="mr-2" variant="danger" @click="onReset">
                <i class="fa fa-ban"></i> Reset
              </b-button>
            </div>
          </b-card>
        </b-col>
      </b-row>
      <!-- <div slot="footer" class="text-center">
        <b-button type="submit" size="sm" variant="primary" @click="onSubmit">
          <i class="fa fa-dot-circle-o"></i> Submit
        </b-button>

        <b-button type="reset" size="sm" variant="danger" @click="onReset">
          <i class="fa fa-ban"></i> Reset
        </b-button>
      </div> -->
      <!--      </b-col>-->
      <!--      </b-row>-->
      <b-row>
        <b-col lg="6"></b-col>
      </b-row>
    </div>

    <b-modal v-if="thai_student==1"
             title="คุณกรอกข้อมูลไม่ครบถ้วน"
             class="modal-danger"
             v-model="dangerModal"
             @ok="dangerModal = false"
             ok-variant="danger"
    >{{ current_erorrtxt }}
    </b-modal>
    <b-modal v-if="thai_student==0"
             title="You didn’t fill your information completely"
             class="modal-danger"
             v-model="dangerModal"
             @ok="dangerModal = false"
             ok-variant="danger"
    >{{ current_erorrtxt }}
    </b-modal>
  </div>
</template>

<script>
import YimoVueEditor from "../../../node_modules/yimo-vue-editor/src/Editor.vue";
import api from "../../service/api";
//import { toUnicode } from 'punycode';
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";

export default {
  components: {YimoVueEditor},
  name: "CreateGeneral",
  data() {
    return {
      number: 0,
      items_prob_eng: [
        {
          BYTECODE: "1",
          BYTEDES: "No Problems"
        }, {
          BYTECODE: "2",
          BYTEDES: "Yes"
        }], items_prob_thai: [
        {
          BYTECODE: "1",
          BYTEDES: "ไม่มีปัญหา"
        }, {
          BYTECODE: "2",
          BYTEDES: "มีปัญหา"
        }
      ],
      std_id: "",
      student: {},
      current_erorrtxt: "",
      dangerModal: false,
      selected_level_edu: "",
      selected_program_edu: "",
      selected_program_id1: "",
      programItems: [],
      selected_program_id: "",
      selected_program_name: "",
      selected_type_univ: "",
      selected_cause_edu: "",
      qn_cause_edu_txt: "",
      selected_prob_edu: "",
      selected_prob_edu_20: "",
      selected_prob_edu_0: "",
      qn_prob_edu_txt: "",
      selected_prob_edu_1: "",
      selected_prob_edu_2: "",
      selected_prob_edu_3: "",
      selected_prob_edu_4: "",
      selected_prob_edu_5: "",
      selected_prob_edu_6: "",
      qn_work_status: "",
      t1: "",
      t2: "",
      t3: "",
      txt_faculty: "",
      txt_university: "",
      txt_address_uni: "",
      lbl_faculty: "",
      lbl_university: "",
      lbl_address_uni: "",
      error_faculty: 0,
      error_university: 0,
      error_address_uni: 0,
      error_prob_edu:0,
      length: 0,
      items: [],
      items2: [],
      actionUpdate: 10,
    };
  },
  components: {
    vSelect
  },
  computed: {
    state() {
      // console.log("xxxxx=", Boolean(this.value));
      return Boolean(this.value);
    }
  },
  methods: {
    onBack() {
      var number = 0;
      // console.log("n==", number)
      var x = parseInt(this.$route.query.x);
      if (this.qn_work_status == 3) {
        number = x - 7;
        this.$router.push("/part3?x=" + number);
      } else {
        number = x - 17;
        this.$router.push("/part2?x=" + number);
      }
    },
    selectProgramOnchange() {
      this.selected_program_id = this.selected_program_id1.PROGRAM_ID;
      this.selected_program_name = this.selected_program_id1.PROGRAM_NAME;
      // console.log("selected_program_id", this.selected_program_id);
      // console.log("selected_program_name", this.selected_program_name);
      // api
      //   .getProgramEduById(this.selected_program_id, this.thai_student)
      //   .then(res => {
      //     this.selected_program_name = res.data.data[0].PROGRAM_NAME;
      //     console.log("selectProgramOnchange", this.selected_program_name);
      //   })
      //   .catch(err => {
      //     console.log(2);
      //     console.log("2", err.toString());
      //   });

    },
    getQuestion: function (section, sex, thaistudent) {
      api
        .getQuestionBySection(section, sex, thaistudent)
        .then(res => {
          var number;
          number = parseInt(this.$route.query.x);
          for (var i = 0; i < res.data.data.length; i++) {
            number = number + 1;
            res.data.data[i].NUMBER = number;
            res.data.data[i].DATA = 0;
          }
          this.items = res.data.data;
          this.number = number;
          // console.log("getQuestion=", this.items);
        })
        .catch(err => {
          console.log("2 getQuestionBySection", err.toString());
        });
    },
    getProgram: function (thaistudent) {
      api
        .getProgramEduAll(thaistudent)
        .then(res => {
          this.programItems = res.data.data;
          // console.log(this.items);
        })
        .catch(err => {
          console.log("2 getQuestionBySection", err.toString());
        });
    },
    getCurrentStudent(studentid) {
      api
        .getStudentGeneral(studentid)
        .then(res => {
          // console.log("res==", res.data.data);
          if (res.data.data.length > 0) {
            this.actionUpdate = 1;
            this.length = res.data.data.length;
            var currentSt = res.data.data[0];
            this.std_id = this.student.STUDENTID;
            this.qn_work_status = currentSt.QN_WORK_STATUS;
            this.selected_level_edu = currentSt.QN_LEVEL_EDU;
            this.selected_program_edu = currentSt.QN_PROGRAM_EDU;
            this.selected_program_id = currentSt.QN_PROGRAM_EDU_ID;
            this.selected_program_id1 = currentSt.QN_PROGRAM_EDU_ID;
            this.selected_program_name = currentSt.QN_PROGRAM_EDU_NAME;
            this.selected_type_univ = currentSt.QN_TYPE_UNIV;
            this.selected_cause_edu = currentSt.QN_CAUSE_EDU;
            this.qn_cause_edu_txt = currentSt.QN_CAUSE_EDU_TXT;
            this.txt_faculty=currentSt.QN_FACULTY;
            this.txt_university=currentSt.QN_UNIVERSITY;
            this.txt_address_uni=currentSt.QN_ADD_UNIVERSITY;
            this.error_prob_edu =0;
            if (this.selected_prob_edu_20 != null) {
              this.selected_prob_edu_20 = currentSt.QN_PROB_EDU;
              this.error_prob_edu=this.error_prob_edu+1;
            } else {
              this.selected_prob_edu_20 = null;
            }
            if (this.selected_prob_edu_20 == 1) {
              this.selected_prob_edu_1 = currentSt.QN_PROB_EDU;
              this.error_prob_edu=this.error_prob_edu+1;
            } else if (this.selected_prob_edu_20 != 1) {
              var selectedData = [];
              var j = -1;
              if (currentSt.QN_PROB_EDU0 != null) {
                j = j + 1;
                selectedData[j] = 0;
                this.error_prob_edu=this.error_prob_edu+1;
              }
              if (currentSt.QN_PROB_EDU2 != null) {
                j = j + 1;
                selectedData[j] = 2;
                this.error_prob_edu=this.error_prob_edu+1;
              }
              if (currentSt.QN_PROB_EDU3 != null) {
                j = j + 1;
                selectedData[j] = 3;
                this.error_prob_edu=this.error_prob_edu+1;
              }
              if (currentSt.QN_PROB_EDU4 != null) {
                j = j + 1;
                selectedData[j] = 4;
                this.error_prob_edu=this.error_prob_edu+1;
              }
              if (currentSt.QN_PROB_EDU5 != null) {
                j = j + 1;
                selectedData[j] = 5;
                this.error_prob_edu=this.error_prob_edu+1;
              }
              this.selected_prob_edu = selectedData;
              this.selected_prob_edu_2 = currentSt.QN_PROB_EDU2;
              this.selected_prob_edu_3 = currentSt.QN_PROB_EDU3;
              this.selected_prob_edu_4 = currentSt.QN_PROB_EDU4;
              this.selected_prob_edu_5 = currentSt.QN_PROB_EDU5;
              this.selected_prob_edu_6 = currentSt.QN_PROB_EDU6;
              this.qn_prob_edu_txt = currentSt.QN_PROB_EDU_TXT;
            }
          } else {
            this.actionUpdate = 0;
            this.$router.push("/logout");
          }
          return this.actionUpdate;
        })
        .catch(err => {
          this.actionUpdate = 10;
          console.log("getCurrentStudent", err.toString());
          this.$router.push("/logout");
        });

    },
    getStudentQuestion(studentId) {
      this.std_id = this.$store.state.user.studentid;
      this.stdstudentId = this.$store.state.user.studentid;
      this.thai_student = this.$store.state.user.thaistudent;
      this.sex = this.$store.state.user.sex;
      this.getQuestion(4, this.sex, this.thai_student);
      this.getProgram(this.thai_student);
      // this.getCurrentStudent();
    },
    setStudent: function () {
      var student = {};
      // console.log("studentId", this.studentId);
      student.std_id = this.$store.state.user.studentid;
      student.qn_year = this.$store.state.user.year;
      student.selected_level_edu = this.selected_level_edu;
      // console.log("selected_level_edu=", this.selected_level_edu);
      student.txt_faculty = this.txt_faculty.replaceAll("'", "`");
      student.txt_university = this.txt_university.replaceAll("'", "`");
      student.txt_address_uni = this.txt_address_uni.replaceAll("'", "`");

      if ((this.selected_level_edu == null) || (this.selected_level_edu == '')) {
        this.items2[0].VALUES = 2;
      } else {
        this.items2[0].VALUES = 1;
      }
      student.selected_program_edu = this.selected_program_edu;
      if (this.selected_program_edu == "2") {
        student.selected_program_id = this.selected_program_id;
        student.selected_program_name = this.selected_program_name;
      } else {
        student.selected_program_id = "";
        student.selected_program_name = "";
      }
      if ((this.selected_program_edu == null) || (this.selected_program_edu == '')) {
        this.items2[1].VALUES = 2;
      } else {
        if (this.selected_program_edu == 1) {
          this.items2[1].VALUES = 1;
        } else if (this.selected_program_edu == 2) {
          if ((this.selected_program_id == '') || (this.selected_program_id == null)) {
            this.items2[1].VALUES = 2;
          } else {
            this.items2[1].VALUES = 1;
          }
        }
      }
      student.selected_type_univ = this.selected_type_univ;
      if ((this.selected_type_univ == null) || (this.selected_type_univ == '')) {
        this.items2[2].VALUES = 2;
      } else {
        this.items2[2].VALUES = 1;
      }
      student.selected_cause_edu = this.selected_cause_edu;
      if (this.selected_cause_edu == "0") {
          student.qn_cause_edu_txt = this.qn_cause_edu_txt.replaceAll("'", "`");
      } else {
        student.qn_cause_edu_txt = "";
      }
      if ((this.selected_cause_edu == null) || (this.selected_cause_edu == '')) {
        this.items2[3].VALUES = 2;
      } else {
        if (this.selected_cause_edu == "0") {
          if ((this.qn_cause_edu_txt == null) || (this.qn_cause_edu_txt == null) || (this.qn_cause_edu_txt == undefined)) {
            this.items2[3].VALUES = 2;
          } else {
            this.items2[3].VALUES = 1;
          }
        } else {
          this.items2[3].VALUES = 1;
        }
      }
      if (this.selected_prob_edu_20 == 1) {
        student.selected_prob_edu_1 = 1;
        this.selected_prob_edu_1 = 1;
        student.selected_prob_edu_2 = "";
        this.selected_prob_edu_2 = "";
        student.selected_prob_edu_3 = "";
        this.selected_prob_edu_3 = "";
        student.selected_prob_edu_4 = "";
        this.selected_prob_edu_4 = "";
        student.selected_prob_edu_5 = "";
        this.selected_prob_edu_5 = "";
        // student.selected_prob_edu_6 = "";
        // this.selected_prob_edu_6 = "";
        student.selected_prob_edu_0 = "";
        this.selected_prob_edu_0 = "";
        student.qn_prob_edu_txt = "";
      } else if (this.selected_prob_edu_20 == 2) {
        student.selected_prob_edu_1 = "";
        this.selected_prob_edu_1 = "";
        student.selected_prob_edu_2 = "";
        this.selected_prob_edu_2 = "";
        student.selected_prob_edu_3 = "";
        this.selected_prob_edu_3 = "";
        student.selected_prob_edu_4 = "";
        this.selected_prob_edu_4 = "";
        student.selected_prob_edu_5 = "";
        this.selected_prob_edu_5 = "";
        // student.selected_prob_edu_6 = "";
        // this.selected_prob_edu_6 = "";
        student.selected_prob_edu_0 = "";
        this.selected_prob_edu_0 = "";
        student.qn_prob_edu_txt = "";

        if (this.selected_prob_edu.length != 0) {
          for (var i = 0; i < this.selected_prob_edu.length; i++) {
            // console.log("xx==", this.selected_prob_edu[i]);
            var ans_prob_edu = this.selected_prob_edu[i];
            if (ans_prob_edu == "0") {
              student.selected_prob_edu_0 = 1;
              this.selected_prob_edu_0 = 1;
              student.qn_prob_edu_txt = this.qn_prob_edu_txt.replaceAll("'", "`");
            } else if (ans_prob_edu == "2") {
              student.selected_prob_edu_2 = 1;
              this.selected_prob_edu_2 = 1;
            } else if (ans_prob_edu == "3") {
              student.selected_prob_edu_3 = 1;
              this.selected_prob_edu_3 = 1;
            } else if (ans_prob_edu == "4") {
              student.selected_prob_edu_4 = 1;
              this.selected_prob_edu_4 = 1;
            } else if (ans_prob_edu == "5") {
              student.selected_prob_edu_5 = 1;
              this.selected_prob_edu_5 = 1;
            }
            // } else if (ans_prob_edu == "6") {
            //   student.selected_prob_edu_6 = 1;
            //   this.selected_prob_edu_6 = 1;
            //
            //   student.qn_prob_edu_txt=this.qn_prob_edu_txt
            //   console.log("xxxxx", this.qn_prob_edu_txt);
            // }
          }
        }
      }
      student.selected_prob_edu = this.selected_prob_edu;
      if (this.selected_prob_edu == 1) {
        this.items2[4].VALUES = 1;
      } else {
        if (this.selected_prob_edu.length == 0) {
          this.items2[4].VALUES = 2;
        } else {
          this.items2[4].VALUES = 1;
        }
      }
      // console.log("setStudent==", student);
      return student;
    },
    getErrorTxt: function () {
      this.current_erorrtxt = "";
      this.numEror = 0;
      var substring = "--";
      var substring1 = "..";
      var substring55 = "55";
      // console.log("qn_prob_edu==",this.items2);
      if ((this.txt_faculty == null) || (this.txt_faculty == "") || (this.txt_faculty == undefined) ) {
        this.error_faculty=2;
        this.numEror = this.numEror + 1;
        this.current_erorrtxt =
          this.thai_student == "1"
            ? this.current_erorrtxt + "/คณะ/สำนักวิชาที่กำลังศึกษาต่อ"
            : this.current_erorrtxt + "/In which faculty/school are you pursuing further studies?";
      }else{
        this.error_faculty=1;
      }
      if ((this.txt_university == null) || (this.txt_university == "") || (this.txt_university == undefined)) {
        this.error_university=2;
        this.numEror = this.numEror + 1;
        this.current_erorrtxt =
          this.thai_student == "1"
            ? this.current_erorrtxt + "/ชื่อสถาบันการศึกษาที่ศึกษาต่อ"
            : this.current_erorrtxt + "/Name of educational institution";
      }else{
        this.error_university=1;
      }
      if ((this.txt_address_uni == null) || (this.txt_address_uni == "") || (this.txt_address_uni == undefined) ) {
        this.error_address_uni=2;
        this.numEror = this.numEror + 1;
        this.current_erorrtxt =
          this.thai_student == "1"
            ? this.current_erorrtxt + "/ที่อยู่ของสถาบันการศึกษาที่ศึกษาต่อ"
            : this.current_erorrtxt + "/Address of educational institution";
      }else{
        this.error_address_uni=1;
      }
      if ((this.selected_level_edu == null) || (this.selected_level_edu == "") || (this.selected_level_edu == "None")) {
        this.numEror = this.numEror + 1;
        this.items2[0].VALUES = 2;
        this.current_erorrtxt =
          this.thai_student == "1"
            ? this.current_erorrtxt + "/ระดับการศึกษา"
            : this.current_erorrtxt + "/Level Education";
      }
      if (
        this.selected_program_edu == null ||
        this.selected_program_edu == ""
      ) {
        this.numEror = this.numEror + 1;
        this.items2[1].VALUES = 2;
        this.current_erorrtxt =
          this.thai_student == "1"
            ? this.current_erorrtxt + "/สาขาวิชา"
            : this.current_erorrtxt + "/Program Education";
      }
      if ((this.selected_program_edu == "2") && ((this.selected_program_id == "") || (this.selected_program_id == "None") || (this.selected_program_id == null) || (this.selected_program_id == 0))) {
        this.numEror = this.numEror + 1;
        this.items2[1].VALUES = 2;
        this.current_erorrtxt =
          this.thai_student == "1"
            ? this.current_erorrtxt + "/ระบุสาขาวิชาใหม่"
            : this.current_erorrtxt + "/Program Education";
      }
      if (this.selected_type_univ == null || this.selected_type_univ == "" || this.selected_type_univ == undefined) {
        this.numEror = this.numEror + 1;
        this.items2[2].VALUES = 2;
        this.current_erorrtxt =
          this.thai_student == "1"
            ? this.current_erorrtxt + "/ประเภทสถาบัน"
            : this.current_erorrtxt + "/Type Univesity";
      }
      // console.log("selected_cause_edu==", this.selected_cause_edu);
      if (this.selected_cause_edu == null || this.selected_cause_edu == "" || this.selected_cause_edu == undefined) {
        this.numEror = this.numEror + 1;
        this.items2[3].VALUES = 2;
        this.current_erorrtxt =
          this.thai_student == "1"
            ? this.current_erorrtxt + "/เหตุผล"
            : this.current_erorrtxt + "/Cause education";
      }
      if (this.selected_cause_edu == "0") {
        if ((this.qn_cause_edu_txt == "") || (this.qn_cause_edu_txt == null)
          || (this.qn_cause_edu_txt == "None") || (this.qn_cause_edu_txt == "-")
          || (this.qn_cause_edu_txt == "."))
          // || ( this.qn_cause_edu_txt == "--" )|| ( this.qn_cause_edu_txt == "---")|| ( this.qn_cause_edu_txt == "----")
        {
          this.numEror = this.numEror + 1;
          this.items2[3].VALUES = 2;
          this.current_erorrtxt =
            this.thai_student == "1"
              ? this.current_erorrtxt + "/อื่นๆ ระบุ"
              : this.current_erorrtxt + "/Other";
        }
        if (this.qn_cause_edu_txt != "") {
          if (this.qn_cause_edu_txt != null) {
            if (this.qn_cause_edu_txt.includes(substring)) {
              this.numEror = this.numEror + 1;
              this.items2[3].VALUES = 2;
              this.current_erorrtxt = this.thai_student == "1" ? this.current_erorrtxt + "/อื่นๆ ระบุ --" : this.current_erorrtxt + "/Other --";
            }
            if (this.qn_cause_edu_txt.includes(substring1)) {
              this.numEror = this.numEror + 1;
              this.items2[3].VALUES = 2;
              this.current_erorrtxt = this.thai_student == "1" ? this.current_erorrtxt + "/อื่นๆ ระบุ --" : this.current_erorrtxt + "/Other --";
            }
            if (this.qn_cause_edu_txt.includes(substring55)) {
              this.numEror = this.numEror + 1;
              this.items2[3].VALUES = 2;
              this.current_erorrtxt = this.thai_student == "1" ? this.current_erorrtxt + "/อื่นๆ ระบุ 55" : this.current_erorrtxt + "/Other 55";
            }
          }
        }
      }
      // console.log("selected_prob_edu==", this.selected_prob_edu_20);
      // console.log("0==", this.selected_prob_edu_0);
      // console.log("1==", this.selected_prob_edu_1);
      // console.log("2==", this.selected_prob_edu_2);
      // console.log("3==", this.selected_prob_edu_3);
      // console.log("4==", this.selected_prob_edu_4);
      // console.log("5==", this.selected_prob_edu_5);
      // console.log("5==", this.selected_prob_edu_5);
      // console.log("qn_prob_edu_txt==", this.qn_prob_edu_txt);
      if ((this.selected_prob_edu_20 == "") || (this.selected_prob_edu_20 == null) || (this.selected_prob_edu_20 == undefined)) {
        this.numEror = this.numEror + 1;
        this.items2[4].VALUES = 2;
        this.current_erorrtxt = this.thai_student == "1" ? this.current_erorrtxt + "/ปัญหาในการศึกษาต่อ" : this.current_erorrtxt + "/Problems to pursue ";
      } else if (this.selected_prob_edu_20 == 2) {
        if ((this.selected_prob_edu.length == 0)) {
          this.numEror = this.numEror + 1;
          this.items2[4].VALUES = 2;
          this.current_erorrtxt = this.thai_student == "1" ? this.current_erorrtxt + "/หากตอบมีปัญหา โปรดระบุปัญหา โดยสามารถเลือกตอบได้หลายข้อ" : this.current_erorrtxt + "/If yes, please choose the reasons. You can choose more than one answer.)";
        }
       /* if (this.selected_prob_edu_20 == 2)  {
          var total=Number(this.selected_prob_edu_1)+Number(this.selected_prob_edu_2)+Number(this.selected_prob_edu_3)+Number(this.selected_prob_edu_4)+Number(this.selected_prob_edu_5)+Number(this.selected_prob_edu_6);
          console.log("total==",total)
          if (total==0){
          this.numEror = this.numEror + 1;
          this.items2[4].VALUES = 2;
          this.current_erorrtxt = this.thai_student == "1" ? this.current_erorrtxt + "/xx" : this.current_erorrtxt + "/xx ";
          }
        } */
        /*  if (this.selected_prob_edu_6 == "1") {
            if ((this.qn_prob_edu_txt == "") || (this.qn_prob_edu_txt == null)
              || (this.qn_prob_edu_txt == "-") || (this.qn_prob_edu_txt == "None")
              || (this.qn_prob_edu_txt == ".")) {
              this.numEror = this.numEror + 1;
              this.items2[4].VALUES = 2;
              this.current_erorrtxt =
                this.thai_student == "1"
                  ? this.current_erorrtxt + "/มีปัญหา อื่นๆให้ระบุ"
                  : this.current_erorrtxt + "/Other";
            }
            if (this.qn_prob_edu_txt != "") {
              if (this.qn_prob_edu_txt != null) {
                if (this.qn_prob_edu_txt.includes(substring)) {
                  this.numEror = this.numEror + 1;
                  this.items2[4].VALUES = 2;
                  this.current_erorrtxt = this.thai_student == "1" ? this.current_erorrtxt + "/มีปัญหา อื่นๆให้ระบุ --" : this.current_erorrtxt + "/Other --";
                }
                if (this.qn_prob_edu_txt.includes(substring1)) {
                  this.numEror = this.numEror + 1;
                  this.items2[4].VALUES = 2;
                  this.current_erorrtxt = this.thai_student == "1" ? this.current_erorrtxt + "/มีปัญหา อื่นๆให้ระบุ --" : this.current_erorrtxt + "/Other --";
                }
                if (this.qn_prob_edu_txt.includes(substring55)) {
                  this.numEror = this.numEror + 1;
                  this.items2[4].VALUES = 2;
                  this.current_erorrtxt = this.thai_student == "1" ? this.current_erorrtxt + "/มีปัญหา อื่นๆให้ระบุ --" : this.current_erorrtxt + "/Other --";
                }
              }
            }
          } */

        if (this.selected_prob_edu_0 == 1) {
          if ((this.qn_prob_edu_txt == '') || (this.qn_prob_edu_txt == '-') || (this.qn_prob_edu_txt == null) || (this.qn_prob_edu_txt == undefined) || (this.qn_prob_edu_txt == "None")) {
            this.numEror = this.numEror + 1;
            this.items2[4].VALUES = 2;
            this.current_erorrtxt = this.thai_student == "1" ? this.current_erorrtxt + "/อื่นๆ ระบุ" : this.current_erorrtxt + "/Other(Please specify)";
          }

          if (this.qn_prob_edu_txt != '') {
            if (this.qn_prob_edu_txt != null) {

              if (this.qn_prob_edu_txt.includes(substring)) {
                this.numEror = this.numEror + 1;
                this.items2[4].VALUES = 2;
                this.current_erorrtxt = this.thai_student == "1" ? this.current_erorrtxt + "/อื่นๆ ระบุ --" : this.current_erorrtxt + "/Other --";
              }
              if (this.qn_prob_edu_txt.includes(substring1)) {
                this.numEror = this.numEror + 1;
                this.items2[4].VALUES = 2;
                this.current_erorrtxt = this.thai_student == "1" ? this.current_erorrtxt + "/อื่นๆ ระบุ .." : this.current_erorrtxt + "/Other ..";
              }
              if (this.qn_prob_edu_txt.includes(substring55)) {
                this.numEror = this.numEror + 1;
                this.items2[4].VALUES = 2;
                this.current_erorrtxt = this.thai_student == "1" ? this.current_erorrtxt + "/อื่นๆ ระบุ 55" : this.current_erorrtxt + "/Other 55";
              }
            }
          }

        }
      }


      // console.log("items2=", this.items2)
      console.log("numEror==",this.numEror);
      if (this.numEror == 0) {
        this.dangerModal = false;
      } else {
        this.dangerModal = true;
      }
      return this.numEror;
    },
    updatePart4(student) {
      api
        .updateStudentPart4(student)
        .then(res => {
          // console.log(res);
          this.message = res.message;
          if (res.data.code == 200) {
            // console.log("update ผ่าน", this.std_id);
            this.nextPart();
          } else {
            this.$router.push("general");

          }
        })
        .catch(err => {
          this.$router.push("/Logout");
          console.log("updatePart2 error", err.toString());
        });
    },
    nextPart() {
      this.number = this.number + 3;
      this.$router.push("/part5?x=" + this.number);
    },
    onReset() {
      this.selected_level_edu = "";
      this.selected_program_edu = "";
      this.selected_program_id1 = "";
      this.selected_type_univ = "";
      this.selected_cause_edu = "";
      this.qn_cause_edu_txt = "";
      this.selected_prob_edu = "";
      this.selected_prob_edu1 = "";
      this.selected_prob_edu2 = "";
      this.selected_prob_edu3 = "";
      this.selected_prob_edu4 = "";
      this.selected_prob_edu5 = "";
      this.qn_prob_edu_txt = "";
    },
    async onSubmit() {
      var student = {}
      this.numEror = this.getErrorTxt();
      if (this.numEror==0) {
        student = this.setStudent();
      }
      // console.log("numEror", this.numEror);
      if (this.numEror == 0) {
        if (this.actionUpdate == 1) {
          // console.log("UPDATE")
          this.updatePart4(student);
        } else {
          this.$router.push("/General");
        }
      }
    }
  },
  mounted() {
  },
  created() {

    for (var j = 42; j <= 46; j++) {
      var b = {ID: j, UPDATEDATA: 0, VALUES: 0}
      this.items2.push(b);
    }

    if (this.$store.state.token == null || this.$store.state.user == null) {
      this.$router.push("/Logout");
    } else {
      // this.$router.push("/Dashboard");
    }
    this.std_id = this.$store.state.user.studentid;
    api.onSetHeader();
    this.actionUpdate = this.getCurrentStudent(this.std_id);
    // console.log("actionUpdate", this.actionUpdate);
    this.getStudentQuestion();
    if (this.thai_student==1){
      this.lbl_faculty="คณะ/สำนักวิชาที่กำลังศึกษาต่อ\n";
      this.lbl_university="ชื่อสถาบันการศึกษาที่ศึกษาต่อ\n";
      this.lbl_address_uni="ที่อยู่ของสถาบันการศึกษาที่ศึกษาต่อ\n";
    }else{
      this.lbl_faculty="In which faculty/school are you pursuing further studies? \n";
      this.lbl_university="Name of educational institution\n";
      this.lbl_address_uni="Address of educational institution\n";
    }

  }
};
</script>
<style>
</style>
